import React from 'react';
import styles from './EntitlementsPanel.module.css';

interface Entitlement {
  name: string;
  status: string;
  expiryDate: string;
  used: number;
  total: number;
  unit: string;
  monthsLeft?: number | null;
}

interface EntitlementsPanelProps {
  entitlements: Entitlement[];
}

export const EntitlementsPanel: React.FC<EntitlementsPanelProps> = ({ entitlements }) => {
  return (
    <div className={styles.entitlementsPanel}>
      <div className={styles.header}>
        <h3 className={styles.title}>Entitlements</h3>
        <a href="#" className={styles.manageLink}>Manage Entitlements</a>
      </div>
      <div className={styles.content}>
        {entitlements.map((entitlement, index) => {
          const percentage = (entitlement.used / entitlement.total) * 100;
          const isExpiring = entitlement.status.toLowerCase().includes('expiring');
          
          return (
            <div key={index} className={styles.entitlementItem}>
              <div className={styles.entitlementRow}>
                <div className={styles.entitlementName}>{entitlement.name}</div>
                <div className={styles.entitlementTotal}>{entitlement.total} {entitlement.unit}</div>
              </div>
              
              <div className={styles.entitlementRow}>
                <div className={styles.entitlementStatus}>
                  {isExpiring ? (
                    <svg className={styles.warningIcon} width="14" height="14" viewBox="0 0 16 16" fill="none">
                      <path d="M8 2L2 14H14L8 2Z" stroke="#ffc107" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M8 6V9" stroke="#ffc107" strokeWidth="1.5" strokeLinecap="round"/>
                      <circle cx="8" cy="11" r="0.5" fill="#ffc107"/>
                    </svg>
                  ) : (
                    <svg className={styles.activeIcon} width="14" height="14" viewBox="0 0 16 16" fill="none">
                      <circle cx="8" cy="8" r="7" stroke="#28a745" strokeWidth="1.5"/>
                      <path d="M5 8L7 10L11 6" stroke="#28a745" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  )}
                  <span className={isExpiring ? styles.expiringText : styles.activeText}>
                    {entitlement.status}
                  </span>
                </div>
                <div className={styles.usagePercentage}>{percentage.toFixed(0)}% used</div>
              </div>

              <div className={styles.progressBar}>
                <div
                  className={`${styles.progressFill} ${isExpiring ? styles.progressExpiring : styles.progressActive}`}
                  style={{ width: `${percentage}%` }}
                ></div>
              </div>

              <div className={styles.entitlementFooter}>
                <div className={styles.expiryDate}>
                  <svg width="12" height="12" viewBox="0 0 16 16" fill="none">
                    <rect x="2" y="3" width="12" height="11" rx="1" stroke="currentColor" strokeWidth="1.5"/>
                    <path d="M2 7H14" stroke="currentColor" strokeWidth="1.5"/>
                  </svg>
                  Expires {entitlement.expiryDate}
                </div>
                {entitlement.monthsLeft && (
                  <div className={isExpiring ? styles.monthsLeftWarning : styles.monthsLeft}>
                    {entitlement.monthsLeft} months left
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

